<template>
  <div
    v-if="page"
    :class="$style.root"
  >
    <PagesProjectsRefactorSlugHeaderComponent :page="page" />
    <CoreBlocksComponent :blocks="page?.blocks" />
    <SharedEventsRelatedComponent :page="page" />
    <SharedRelatedComponent :page="page" />
    <SharedPressComponent :page="page" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const localizedData = baseStrapiGetLocalizedData(props.data)
const page = baseStrapiGetAttributes(localizedData)
</script>

<style module>
.root {
}
</style>
